<template>
  <div class="dvp-modal__top">
    <basic-close-button
      v-if="instance?.exposed.closeable"
      aria-label="Close Modal"
      :size="closeButtonSize"
      @click="instance.parent.exposed.close()"
    />
    <slot />
  </div>
</template>

<script setup>
  import { computed, getCurrentInstance, onMounted, ref } from 'vue'

  import BasicCloseButton from '@shared/components/Basic/CloseButton'

  // DATA
  const instance = ref()

  // COMPUTED
  const closeButtonSize = computed(() => {
    return ['maxi', 'full'].includes(instance.value.props.size) ? 'lg' : 'sm'
  })

  // METHODS

  // LIFECYCLE HOOKS
  onMounted(() => {
    instance.value = getCurrentInstance().parent
  })
</script>

<style scoped>
.dvp-modal__top {
  display: flex;
  justify-content: flex-end;
  padding: var(--dotcom-responsive-gutter-responsive) var(--dotcom-responsive-gutter-responsive)
    var(--dotcom-responsive-spacing-res-xs);
}
</style>
